import { render, staticRenderFns } from "./CommentMenu.vue?vue&type=template&id=56b26e7e&"
import script from "./CommentMenu.vue?vue&type=script&lang=js&"
export * from "./CommentMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports